import { tryCatchHelper } from '../../../helpers';
import { ACTIVO_VISTAS, ALL_VISTAS, LOADING_ALL_VISTAS } from './VistasReducer';
import {
  allVistasService,
  deleteVistasService,
  oneVistasService,
  saveVistasService,
} from './VistasService';

export const allVistasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_VISTAS, payload: true });
    const res = await allVistasService(params);
    dispatch({ type: ALL_VISTAS, payload: res.data });
    dispatch({ type: LOADING_ALL_VISTAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_VISTAS, payload: false });
    tryCatchHelper(e);
  }
};

export const saveVistasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveVistasService(id, data);
    notify(res.data.message);
    await allVistasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoVistasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_VISTAS, payload: data });
};

export const oneVistasAction = async (dispatch, id) => {
  try {
    const res = await oneVistasService(id);
    await setActivoVistasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteVistasAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteVistasService(id);
    await setActivoVistasAction(dispatch, null);
    notify(res.data.message);
    await allVistasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
